module.exports = __webpack_public_path__ + "img/background.b775f002.webp";